import { render, staticRenderFns } from "./OfferPause.vue?vue&type=template&id=c5000fce&scoped=true"
import script from "./OfferPause.vue?vue&type=script&lang=js"
export * from "./OfferPause.vue?vue&type=script&lang=js"
import style0 from "./OfferPause.vue?vue&type=style&index=0&id=c5000fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5000fce",
  null
  
)

export default component.exports